export const borderRadius = '0.25rem'
